import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a1ca83e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Resources footer-white-after padded" }
const _hoisted_2 = { "data-scroll-section": "" }
const _hoisted_3 = ["href", "download"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<span class=\"cta\" data-v-7a1ca83e><span class=\"cta__icon\" data-v-7a1ca83e><svg viewBox=\"0 0 17 14\" data-v-7a1ca83e><use xlink:href=\"#i-arrow-right--alt\" data-v-7a1ca83e></use></svg></span><span class=\"cta__icon cta__icon--hover\" data-v-7a1ca83e><svg viewBox=\"0 0 17 14\" data-v-7a1ca83e><use xlink:href=\"#i-arrow-right--alt\" data-v-7a1ca83e></use></svg></span></span>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LineByLine = _resolveComponent("LineByLine")!
  const _component_AppearObject = _resolveComponent("AppearObject")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createVNode(_component_AppearObject, null, {
        default: _withCtx(() => [
          _createElementVNode("h1", null, [
            _createVNode(_component_LineByLine, {
              innerHTML: _ctx.$t('resources.title')
            }, null, 8, ["innerHTML"])
          ])
        ]),
        _: 1
      })
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resources, (section, sectionIndex) => {
      return (_openBlock(), _createElementBlock("section", {
        key: 'resources-section-' + sectionIndex,
        "data-scroll-section": ""
      }, [
        _createElementVNode("h2", null, _toDisplayString(section.title), 1),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.items, (item, itemIndex) => {
            return (_openBlock(), _createElementBlock("li", {
              key: 'resources-item-' + sectionIndex + '-' + itemIndex,
              class: "Resource"
            }, [
              _createElementVNode("a", {
                href: item.url,
                download: item.download,
                target: "_blank"
              }, [
                _createElementVNode("h3", {
                  innerHTML: item.title
                }, null, 8, _hoisted_4),
                _hoisted_5
              ], 8, _hoisted_3)
            ]))
          }), 128))
        ])
      ]))
    }), 128))
  ]))
}